import { object, string, boolean as bool, ObjectSchema } from 'yup';

import { PHONE_REGEX } from '../../../../helpers/validation.helpers';

export interface IValidatorParams {
  useEmail?: boolean;
  usePhone?: boolean;
  useQuestion?: boolean;
  usePolicy?: boolean;
}

export const buildValidationSchema = ({
  useEmail = true,
  usePhone = true,
  useQuestion = true,
  usePolicy = true,
}: IValidatorParams): ObjectSchema =>
  object().shape({
    email: useEmail ? string().trim().required().min(3).max(255).email() : string(),
    phone: usePhone
      ? string()
          .trim()
          .required()
          .min(10)
          .matches(PHONE_REGEX, {
            message: 'Please enter a valid phone number.',
            excludeEmptyString: true,
          })
          .max(25)
      : string(),
    answer: useQuestion ? string().trim().required().min(3).max(255) : string(),
    policy: usePolicy ? bool().oneOf([true], 'Please accept the terms.') : bool(),
  });
